"use client"

import dynamic from 'next/dynamic'
import { Suspense, useState } from 'react'
import { useRegionId } from '@/shared/hooks/use-region-id'
import { migrationPlugins } from '@/features/migration/plugins/registry'
import MigrationPlaceholder from '@/features/migration/components/migration-placeholder'
import LocationSelector from '@/shared/components/location-selector'

const LoadingState = () => (
  <div className="flex h-48 items-center justify-center">
    <div className="h-8 w-8 animate-spin rounded-full border-b-2 border-primary" />
  </div>
)

function MigrationTab() {
  const { regionId, region, isLoading } = useRegionId()
  const [selectedRegionId, setSelectedRegionId] = useState<string | null>(null)

  if (isLoading) {
    return <LoadingState />
  }

  if (!regionId) {
    return (
      <div className="flex flex-col gap-7">
        <div className="flex flex-col gap-4 md:flex-row md:justify-between md:items-start">
          <div>
            <h3 className="text-lg font-semibold">{region?.name ? `${region.name} Migration` : 'Migration'}</h3>
            <p className="text-muted-foreground text-sm mt-1">
              Migration tools for this region
            </p>
          </div>
          <LocationSelector onLocationChange={setSelectedRegionId} />
        </div>
        <MigrationPlaceholder />
      </div>
    )
  }

  const Plugin = migrationPlugins[regionId]

  if (!Plugin) {
    return (
      <div className="flex flex-col gap-7">
        <div className="flex flex-col gap-4 md:flex-row md:justify-between md:items-start">
          <div>
            <h3 className="text-lg font-semibold">{region?.name ? `${region.name} Migration` : 'Migration'}</h3>
            <p className="text-muted-foreground text-sm mt-1">
              Migration tools for this region
            </p>
          </div>
          <LocationSelector onLocationChange={setSelectedRegionId} />
        </div>
        <MigrationPlaceholder regionName={region?.name} />
      </div>
    )
  }

  return (
    <Suspense fallback={<LoadingState />}>
      <div className="flex flex-col gap-7">
        <div className="flex flex-col gap-4 md:flex-row md:justify-between md:items-start">
          <div>
            <h3 className="text-lg font-semibold">{region?.name ? `${region.name} Migration` : 'Migration'}</h3>
            <p className="text-muted-foreground text-sm mt-1">
              Migration tools for this region
            </p>
          </div>
          <LocationSelector onLocationChange={setSelectedRegionId} />
        </div>
        <Plugin />
      </div>
    </Suspense>
  )
}

export default MigrationTab

